const getMediaUrl = (imgUrl: string) => {
  if (process.env.NODE_ENV === 'development' && imgUrl[0] === '/') {
    console.error('Your image path should not include a / at the beginning');
  }
  if (typeof window !== 'undefined') {
    return `${window.MEDIA_URL}${imgUrl}`;
  }
  return `/media/${imgUrl}`;
};

export default getMediaUrl;
